import getConfig from 'next/config';

export const getPricingIndicatorBucketedCookie = (): string => {
  const {
    publicRuntimeConfig: { PRICING_INDICATOR_EXPERIMENT_KEY },
  } = getConfig();
  return `convert_bucketed_${PRICING_INDICATOR_EXPERIMENT_KEY}`;
};
